var path = 'app/scripts/modules/core/src/serverGroup/pod/runningTasksTag.html';
var html = "<span ng-if=\"tasks.length || runningExecutions().length\">\n  <span uib-popover-template=\"popoverTemplate\"\n        popover-class=\"menu-running-tasks\"\n        popover-trigger=\"'mouseenter'\"\n        popover-placement=\"bottom\"\n  >\n    <span class=\"icon\"><span class=\"glyphicon icon-spinner fa-spin-slow\"></span></span>\n  </span>\n</span>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/core/src/serverGroup/pod/runningTasksTag.html
// module id = 1082
// module chunks = 0